import { ButtonViewProps } from '../../types';
import styles from './CreateTicket.module.scss';

export const CreateTicket = ({ children }: ButtonViewProps) => <div className={styles.createTicket}>{children}</div>;
